export const HORIZON_VIEWS = {
  LIST: 'list',
  HORIZON: 'horizon',
};

export const HORIZON_VIEW_QUERY_PARAM = 'view';

export const GROUP_BY_OPTIONS = [
  { value: 'location', label: 'Location' },
  { value: 'user', label: 'User' },
  { value: 'subcategory', label: 'Sub Category' },
  { value: 'priority', label: 'Priority' },
];

export const DEFAULT_GROUP_BY = 'location';

export const HORIZON_DATE_WINDOW = {
  DAYS_BEFORE: 3,
  DAYS_AFTER: 4,
  MIN_DAYS: 8,
  MAX_DAYS: 15,
};

export const HORIZON_FILTER_KEYS = {
  STATUS: 'status',
  PRIORITY: 'priority',
  LOCATION: 'location',
  SUBCATEGORY: 'subcategory',
  USER: 'user',
};

export const HORIZON_FILTER_CHIPS = [
  { key: HORIZON_FILTER_KEYS.STATUS, label: 'Status' },
  { key: HORIZON_FILTER_KEYS.PRIORITY, label: 'Priority' },
  { key: HORIZON_FILTER_KEYS.LOCATION, label: 'Location' },
  { key: HORIZON_FILTER_KEYS.SUBCATEGORY, label: 'Sub Category' },
  { key: HORIZON_FILTER_KEYS.USER, label: 'User' },
];

export const HORIZON_STATUS_OPTIONS = [
  { value: 0, label: 'Pending Submission' },
  { value: 2, label: 'Pending Approval' },
  { value: 3, label: 'Approved' },
];

export const HORIZON_DEFAULT_STATE = {
  horizonStartDate: null,
  horizonEndDate: null,
  anchoredDate: null,
  userType: 'manager',
  selectedTabStage: null,
  activeHorizonFilters: {},
  selectedGroupByCondition: DEFAULT_GROUP_BY,
  selectedCell: null,
};

export const HORIZON_STAGE_BADGE = {
  0: 'Pending Submission',
  2: 'Pending Approval',
  3: 'Approved',
};
